module.exports = __webpack_public_path__ + "static/media/alustech-icon.1dae9c4a.png";